import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PolicyAppState } from '../types';
import { PoliciesReduxActions } from '../actions';
import { PolicySaveRestriction } from './types.save';

// SELECTORS
export const getIsLoading = (state: PolicyAppState): boolean => state.saveButtonSlice.isLoading;
export const getIsSaving = (state: PolicyAppState): boolean => state.saveButtonSlice.isSaving;
export const getSaveRestriction = (state: PolicyAppState): PolicySaveRestriction => state.saveButtonSlice.restriction;
export const getIsWaitingValidation = (state: PolicyAppState): boolean => state.saveButtonSlice.isWaitingValidation;
export const getCloneVisibility = (state: PolicyAppState): boolean =>
  !state.phantom &&
  Application.Main.hasAnyRights([Constants.Rights.RIGHT_MANAGE_POLICIES_WRITE]) &&
  (state.saveButtonSlice.restriction === PolicySaveRestriction.DEFAULT_POLICY ||
    state.saveButtonSlice.restriction === PolicySaveRestriction.OTHER_USER ||
    state.saveButtonSlice.restriction === PolicySaveRestriction.OTHER_COMPANY);

// ACTIONS
export const setIsLoading = createAction<boolean>(PoliciesReduxActions.SET_IS_LOADING);
export const setIsLoadingActionHandler = (state: PolicyAppState, action: PayloadAction<boolean>): void => {
  state.saveButtonSlice.isLoading = action.payload;
};

export const setIsSaving = createAction<boolean>(PoliciesReduxActions.SET_IS_SAVING);
export const setIsSavingActionHandler = (state: PolicyAppState, action: PayloadAction<boolean>): void => {
  state.saveButtonSlice.isSaving = action.payload;
};

export const setSaveRestriction = createAction<PolicySaveRestriction>(PoliciesReduxActions.SET_SAVE_RESTRICTION);
export const setSaveRestrictionActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<PolicySaveRestriction>
): void => {
  state.saveButtonSlice.restriction = action.payload;
};

export const setIsWaitingValidation = createAction<boolean>(PoliciesReduxActions.SET_IS_WAITING_VALIDATION);
export const setIsWaitingValidationActionHandler = (state: PolicyAppState, action: PayloadAction<boolean>): void => {
  state.saveButtonSlice.isWaitingValidation = action.payload;
};
